import { store } from '@betacrew/jars-flux';
export const componentKey = "ACCOUNTINGSUITE_SWITCH";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setFormAndTaxYearList: (state, action) => {
            state.formAndTaxYearList = action.payload;
        },
        setAuthorizationUrl: (state, action) => {
            state.authorizationUrl = action.payload;
        },
        setTenantList: (state, action) => {
            state.tenantList = action.payload;
        },
        setImportData: (state, action) => {
            state.importData = action.payload;
        },
        setIsImportDataGridViewLoaded: (state, action) => {
            state.isImportDataGridViewLoaded = action.payload;
        },
        setFormSettings: (state, action) => {
            state.formSettings = action.payload;
        },
    },
    initialReducerState: {
        loadingState: false,
        formAndTaxYearList: {},
        authorizationUrl: '',
        tenantList: [],
        importData: null,
        isImportDataGridViewLoaded: false,
        formSettings: null,
    }
});
export const { setLoadingState, setFormAndTaxYearList,  setAuthorizationUrl, setTenantList, setImportData, setIsImportDataGridViewLoaded, setFormSettings } = actions;